import { render, staticRenderFns } from "./NewIssue.vue?vue&type=template&id=1b0544ac&"
import script from "./NewIssue.vue?vue&type=script&lang=ts&"
export * from "./NewIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports